import type {
  AdminPlan,
  BillingInterval,
  CreatePlanPayload,
  UpdatePlanPayload,
} from './api';

export const PLAN_INTERVALS: BillingInterval[] = ['monthly', 'yearly', 'custom'];

export interface PlanFormState {
  code: string;
  name: string;
  description: string;
  billing_interval: BillingInterval;
  currency: string;
  unit_amount: string;
  trial_days: string;
  is_active: boolean;
}

export function emptyPlanForm(): PlanFormState {
  return {
    code: '',
    name: '',
    description: '',
    billing_interval: 'monthly',
    currency: 'USD',
    unit_amount: '0.00',
    trial_days: '0',
    is_active: true,
  };
}

export function planFormFromPlan(plan: AdminPlan): PlanFormState {
  return {
    code: plan.code,
    name: plan.name,
    description: plan.description ?? '',
    billing_interval: plan.billing_interval,
    currency: plan.currency,
    unit_amount: plan.unit_amount,
    trial_days: String(plan.trial_days),
    is_active: plan.is_active,
  };
}

export function planFormToCreate(form: PlanFormState, trialDays: number): CreatePlanPayload {
  return {
    code: form.code.trim(),
    name: form.name.trim(),
    description: form.description.trim() || null,
    billing_interval: form.billing_interval,
    currency: form.currency.trim().toUpperCase(),
    unit_amount: form.unit_amount.trim(),
    trial_days: trialDays,
    is_active: form.is_active,
  };
}

export function planFormToUpdate(form: PlanFormState, trialDays: number): UpdatePlanPayload {
  return {
    name: form.name.trim(),
    description: form.description.trim() || null,
    billing_interval: form.billing_interval,
    currency: form.currency.trim().toUpperCase(),
    unit_amount: form.unit_amount.trim(),
    trial_days: trialDays,
    is_active: form.is_active,
  };
}
